import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=1556a7ea&"
import script from "./Richtext.vue?vue&type=script&lang=js&"
export * from "./Richtext.vue?vue&type=script&lang=js&"
import style0 from "./Richtext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports